import { Car, Wrench, Gauge, ScrollText, Truck, User } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ComplaintTypeCard } from "./ComplaintTypeCard";
import { useIsMobile } from "@/hooks/use-mobile";
import { supportLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

export type ComplaintType = {
  id: string;
  icon: JSX.Element;
  label: string;
  description: string;
};

const complaintTypeIds = [
  { id: "body", icon: Car },
  { id: "engine", icon: Wrench },
  { id: "interior", icon: Car },
  { id: "underbody", icon: Car },
  { id: "tires", icon: Gauge },
  { id: "brakes", icon: Gauge },
  { id: "missing_documents", icon: ScrollText },
  { id: "mileage", icon: Gauge },
  { id: "incorrect_details", icon: Car },
  { id: "delivery_delay", icon: Truck },
  { id: "other", icon: User },
] as const;

function getComplaintTypes(
  lang: ReturnType<typeof getLanguage>,
): ComplaintType[] {
  const types = supportLabels(lang).complaintTypes ?? {};
  return complaintTypeIds.map(({ id, icon: Icon }) => {
    const t = types[id];
    const label = typeof t?.label === "string" ? t.label : id;
    const description = typeof t?.description === "string" ? t.description : "";
    return {
      id,
      icon: <Icon className="w-4 h-4 sm:w-5 sm:h-5" />,
      label,
      description,
    };
  });
}

interface ComplaintTypeSelectorProps {
  onSelect: (type: ComplaintType) => void;
}

export const ComplaintTypeSelector = ({
  onSelect,
}: ComplaintTypeSelectorProps) => {
  const isMobile = useIsMobile();
  const complaintTypes = getComplaintTypes(getLanguage());

  return (
    <div className="w-full mx-4 px-4">
      <ScrollArea className={`h-[350px] sm:h-[400px] md:h-[450px]`}>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 px-6 py-4">
          {complaintTypes.map((type) => (
            <ComplaintTypeCard key={type.id} type={type} onSelect={onSelect} />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};
